<template>
  <div class="form-box" v-loading="loading">
    <el-container>
      <el-aside>
        <base-screen title="会员信息">
          <el-autocomplete
            type="text"
            class="inline-input"
            popper-class="my-autocomplete"
            v-model="param.parameter"
            placeholder="会员姓名/卡号/手机号"
            @select="handleSelectMember"
            :fetch-suggestions="querySearchMember">
            <template slot-scope="{ item }">
              <div class="name">会员姓名：{{ item.name }}</div>
              <div class="addr">会员卡号：{{ item.memberNo }}</div>
              <div class="addr">联系方式：{{ item.phone }}</div>
            </template>
          </el-autocomplete>
          <base-img class="img" :src="headImg" errType="headImg" width="100px"/>
          <div class="user-info">
            <div>姓名：{{name}}</div>
            <div>性别：{{sex}}</div>
          </div>
          <div class="user-info">
            <div>会员卡号：{{memberNo}}</div>
            <div>会员生日：{{birthday}}</div>
          </div>
          <div class="user-info">
            <div>联系方式：{{phone}}</div>
            <div>剩余次数：{{balanceNumber}}</div>
            <div>账户余额：{{balanceMoney}}</div>
          </div>

          <div class="">
            <el-table
              :data="serveData"
              v-loading="serveDataLoading"
              border
              style="width: 100%">
              <el-table-column
                prop="serviceName"
                label="服务名称"
              >
              </el-table-column>
              <el-table-column
                prop="totalNum"
                width="70"
                label="总次数"
              >
              </el-table-column>
              <el-table-column
                width="60"
                label="剩余"
              >
                <template slot-scope="{row}">
                  <span class="greenColumn">{{row.surplusNum}}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChangeLeft"
              @current-change="handleCurrentChangeLeft"
              :current-page="pageLeft.pageNum"
              :page-size="pageLeft.pageSize"
              layout="total, prev, pager, next"
              :total="pageLeft.total">
            </el-pagination>
          </div>

        </base-screen>
      </el-aside>

      <el-main>
        <base-screen
          title="充次服务">
          <el-form
            :model="form"
            :rules="rules"
            :inline="true"
            class="demo-form-inline"
            ref="form"
          >
            <div class="tr">
              <el-button type="primary" @click.prevent="addRow">添加充次</el-button>
            </div>
            <el-table
              :data="subDataList"
              ref="subData"
              tooltip-effect="dark"
              max-height="200"
              stripe
            >
              <el-table-column
                label="服务名称"
              >
                <template slot-scope="scope">
                  <el-cascader
                    v-model="scope.row.list"
                    :props="defaultProps"
                    placeholder="请选择服务名称"
                    :options="serveOptions"
                    @change="handleServeChange($event,scope.$index)">
                  </el-cascader>
                </template>
              </el-table-column>
              <el-table-column
                label="充值数量"
                align="center"
              >
                <template slot-scope="scope">
                  <el-input-number
                    v-model="scope.row.num"
                    @change="handleNumChange($event,scope.$index)"
                    :min="1"
                    label="充值数量">
                  </el-input-number>
                </template>
              </el-table-column>
              <el-table-column
                label="每次服务单价"
                align="center"
              >
                <template slot-scope="scope">
                  <el-input
                    placeholder="请输入单价"
                    v-model="scope.row.price"
                    @change="handlePriceChange($event,scope.$index)"
                    clearable>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                width="111">
                <template slot-scope="scope">
                  <el-button
                    @click.native.prevent="delData(scope.$index)"
                    type="text"
                    size="small">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="totalNumber">充值总次数：{{totalNumber}}次</div>
            <el-form-item
              prop="amount"
              label="总费用："
            >
              <el-input type="text" v-model="form.amount" :disabled=true placeholder=""></el-input>
            </el-form-item>

            <el-form-item
              prop="chargeMode"
              label="支付方式："
            >
              <el-select v-model="form.chargeMode" clearable placeholder="请选择支付方式">
                <el-option
                  v-for="item in chargeModeOption"
                  :key="item.dictItemCode"
                  :label="item.dictItemName"
                  :value="item.dictItemCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="remark"
              label="备注："
              class="ipt-textarea"
            >
              <el-input style="width: 400px" type="textarea" v-model="form.remark" placeholder="请填写备注"
                        resize="none"></el-input>
            </el-form-item>
            <el-form-item>
              <div class="tc" style="text-align: center">
                <el-button
                  style="width: 140px"
                  type="primary"
                  v-pms="'charge'"
                  @click="onSubmitRecharge">充值
                </el-button>
              </div>
            </el-form-item>
          </el-form>
        </base-screen>
        <div class="page-box">
          <el-form :inline="true" :model="tableParam" label-position="left"
                   class="demo-form-inline"
                   ref="screenForm"
                   @keydown.native.enter="searchSubmit"
                   @submit.native.prevent>
            <el-form-item label="充值时间：">
              <el-date-picker
                v-model="intervalData"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="支付方式：">
              <el-select v-model="tableParam.chargeMode" clearable placeholder="请选择支付方式">
                <el-option
                  v-for="item in chargeModeOption"
                  :key="item.dictItemCode"
                  :label="item.dictItemName"
                  :value="item.dictItemCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button class="btn-screen" type="primary" @click="searchSubmit">查询</el-button>
              <el-button type="text" @click="resetSearchSubmit">重置</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="tableData"
            v-loading="tableDataLoading"
            border
            style="width: 100%">
            <el-table-column
              fixed
              prop="createTime"
              width="170px"
              label="充值日期"
            >
            </el-table-column>
            <el-table-column
              prop="memberNo"
              width="150px"
              label="会员卡号"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="会员名称"
              width="100">
            </el-table-column>
            <el-table-column
              prop="chargeContent"
              label="充值服务"
              width="200">
            </el-table-column>
            <el-table-column
              prop="chargeNum"
              label="充值次数"
              width="80">
            </el-table-column>
            <el-table-column
              prop="price"
              label="单次费用"
              width="80">
            </el-table-column>
            <el-table-column
              prop="amount"
              label="总费用"
              width="70">
            </el-table-column>
            <el-table-column
              prop="chargeSource"
              label="支付渠道"
              :formatter="handleChargeSource"
              width="80">
            </el-table-column>
            <el-table-column
              prop="chargeMode"
              label="支付方式"
              :formatter="handleChargeMode"
              width="80">
            </el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
            >
            </el-table-column>
            <el-table-column
              fixed="right"
              prop="chargeUser"
              label="操作人"
              width="100">
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNum"
            :page-sizes="[10, 15, 20]"
            :page-size="page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {member, dict, serve} from '../../api'
import {getSession} from '../../utils/session'
import {USER_ID, USER_NAME, ORG_CODE} from '../../constants'
import dayjs from 'dayjs'
import {plus, times} from 'number-precision'

export default {
  name: 'MemberRecharge',
  props: {
    memberId: String
  },
  mounted () {
    if (this.memberId) {
      this.getMember()
    }
    this.getChargeMode()
    this.getServeTree()
  },
  data () {
    return {
      loading: false,
      submitting: false,
      intervalData: [],
      serveOptions: [],
      tableDataLoading: false,
      serveDataLoading: false,
      headImg: '',
      balanceMoney: '',
      balanceNumber: '',
      birthday: '',
      totalNumber: 1,
      name: '',
      phone: '',
      sex: '',
      memberNo: '',
      tableData: [],
      serveData: [],
      memberNames: [],
      chargeModeOption: [],
      subDataList: [{
        serveName: '',
        serveId: '',
        num: '1',
        price: '',
        list: []
      }],
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pages: 0
      },
      pageLeft: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pages: 0
      },
      tableParam: {
        orgCode: getSession(ORG_CODE),
        memberId: '',
        chargeType: '2',
        beginDate: '',
        endDate: '',
        chargeMode: ''
      },
      param: {
        parameter: ''
      },
      form: {
        orgCode: getSession(ORG_CODE),
        memberId: '',
        memberNo: '',
        chargeType: '2',
        chargeUser: getSession(USER_NAME),
        createUser: getSession(USER_ID),
        amount: '',
        chargeMode: '5',
        remark: '',
        memberRechargeLogDetailList: []
      },
      defaultProps: {
        value: 'id',
        label: 'name'
      },
      rules: {
        chargeMode: [
          {required: true, message: '请选择支付方式', trigger: 'change'}
        ]
      }
    }
  },
  components: {},
  watch: {
    intervalData (val) {
      let has = !!val && val.length > 0
      this.tableParam.beginDate = has ? dayjs(val[0]).format('YYYY-MM-DD') : ''
      this.tableParam.endDate = has ? dayjs(val[1]).format('YYYY-MM-DD') : ''
    },
    memberId (val) {
      this.memberId = val
      this.getMember()
    }
  },
  methods: {
    async getTableData () {
      this.tableDataLoading = true
      let {data, page} = await member.pageMemberRechargeLog({
        param: this.tableParam,
        page: this.page
      })
      this.tableDataLoading = false
      this.tableData = data
      this.page = page
    },
    async getTableDataLeft () {
      this.serveDataLoading = true
      let {data, page} = await member.pageBalance({
        param: {
          orgCode: getSession(ORG_CODE),
          memberId: this.tableParam.memberId,
          type: '1'
        },
        page: this.page
      })
      this.serveDataLoading = false
      this.serveData = data
      this.pageLeft = page
    },
    async getMemberBalance () {
      let {data} = await member.getMemberBalance({
        memberId: this.tableParam.memberId,
        type: '1'
      })
      this.balanceNumber = data.balanceNumber
      this.balanceMoney = data.balance
    },
    async getMember () {
      let {data} = await member.getMemberList({
        orgCode: getSession(ORG_CODE),
        parameter: ''
      })
      let obj = data.find(item => item.memberId === this.memberId)
      this.handleSelectMember(obj)
    },
    async getChargeMode () {
      let {data} = await dict.getDictList({
        dictTypeCode: 'CHARGE_MODE'
      })
      let obj = {
        dictItemCode: '0',
        dictItemDesc: '余额支付',
        dictItemId: '00',
        dictItemName: '会员余额',
        dictTypeCode: 'CHARGE_MODE'
      }
      data.push(obj)
      this.chargeModeOption = data
    },
    async getServeTree () {
      let {data} = await serve.getSelTree(getSession(ORG_CODE))
      this.serveOptions = data
    },
    async querySearchMember (queryString, cb) {
      if (queryString) {
        let {data} = await member.getMemberList({
          orgCode: getSession(ORG_CODE),
          parameter: queryString
        })
        this.memberNames = data.filter(this.createChannelFilter(queryString))
      } else {
        this.memberNames = []
      }
      // 调用 callback 返回建议列表的数据
      cb(this.memberNames)
    },
    createChannelFilter (queryString) {
      return (member) => {
        return (member.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1) ||
            (member.phone.indexOf(queryString.toLowerCase()) > -1) ||
            (member.memberNo.toLowerCase().indexOf(queryString.toLowerCase()) > -1)
      }
    },
    handleSelectMember (item) {
      this.param.parameter = item.name
      this.phone = item.phone.substr(0, 3) + '****' + item.phone.substr(7, 11)
      this.sex = item.sex === '1' ? ' 男' : ' 女'
      this.name = item.name
      this.birthday = item.birthday
      this.memberNo = item.memberNo
      this.headImg = item.headImg
      this.form.memberNo = item.memberNo
      this.form.memberId = item.memberId
      this.tableParam.memberId = item.memberId
      this.getMemberBalance()
      this.getTableData()
      this.getTableDataLeft()
    },
    async onSubmitRecharge () {
      this.$confirm(`确定给会员：【${this.name}】充次么?`, '系统提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        callback: async (action, instance) => {
          if (action === 'confirm') {
            if (!this.form.memberId || !this.form.memberNo) {
              this.$message({
                type: 'error',
                message: '请先选择会员'
              })
              return
            }
            if (this.subDataList.length === 0) {
              this.$message({
                type: 'error',
                message: '至少要添加一条充次'
              })
              return
            }
            for (let table of this.subDataList) {
              if (table.list.length === 0) {
                this.$message({
                  type: 'error',
                  message: '请选择服务'
                })
                return
              }
              if (!table.price) {
                this.$message({
                  type: 'error',
                  message: '请填写单价'
                })
                return
              }
            }
            await this.$refs.form.validate()
            this.submitting = true
            this.loading = true
            this.form.memberRechargeLogDetailList = this.subDataList.map(x => ({
              chargeContentId: x.serveId,
              chargeContent: x.serveName,
              price: x.price,
              chargeNum: x.num
            }))
            let {code, msg} = await member.addMemberRechargeLog(this.form)
            this.submitting = false
            this.loading = false
            if (code === 0) {
              this.$message({
                type: 'success',
                message: msg || '充次成功'
              })
              this.getTableData()
              this.getMemberBalance()
              this.getTableDataLeft()
              this.$bus.$emit('MemberRechargeManagement:getMemberBalance')
              this.form.amount = ''
              this.form.chargeMode = '5'
              this.form.remark = ''
              this.subDataList = [{
                serveName: '',
                serveId: '',
                num: '1',
                price: '',
                list: []
              }]
              this.totalNumber = 1
            } else {
              this.$message({
                type: 'error',
                message: msg || '充次失败'
              })
            }
          } else {
            this.$message({
              type: 'info',
              message: '取消充次'
            })
          }
        }
      })
    },
    searchSubmit () {
      if (!this.form.memberId || !this.form.memberNo) {
        this.$message({
          type: 'error',
          message: '请先选择会员'
        })
        return
      }
      this.page.pageNum = 1
      this.getTableData()
    },
    resetSearchSubmit () {
      if (!this.form.memberId || !this.form.memberNo) {
        this.$message({
          type: 'error',
          message: '请先选择会员'
        })
        return
      }
      this.$refs.screenForm.resetFields()
      this.intervalData = []
      this.tableParam.beginDate = ''
      this.tableParam.endDate = ''
      this.tableParam.chargeMode = ''
      this.getTableData()
    },
    async handleServeChange (val, index) {
      this.subDataList[index].serveId = val[val.length - 1]
      this.$nextTick(() => {
        let result = document.getElementsByClassName('el-cascader__label')[0].innerText.split('/')
        this.subDataList[index].serveName = result[1].replace(/\s+/g, '')
      })
      let {data} = await serve.getServeDetail(val[val.length - 1])
      this.subDataList[index].price = data.price
      this.sumAmount()
    },
    handleNumChange (val, index) {
      this.subDataList[index].num = val
      this.sumAmount()
    },
    handlePriceChange (val, index) {
      this.subDataList[index].price = val
      this.sumAmount()
    },
    // 增加行
    addRow () {
      let list = {
        serveName: '',
        serveId: '',
        num: '1',
        price: '',
        list: []
      }
      this.subDataList.unshift(list)
      this.sumAmount()
    },
    // 删除行
    delData (index) {
      this.subDataList.splice(index, 1)
      this.sumAmount()
    },
    sumAmount () {
      this.form.amount = 0
      this.totalNumber = 0
      this.subDataList.map(x => {
        this.form.amount = plus(this.form.amount, times(x.num, x.price))
      })
      this.subDataList.map(x => {
        this.totalNumber = plus(this.totalNumber, x.num)
      })
    },
    handleChargeMode (row) {
      let result = this.chargeModeOption.find(item => item.dictItemCode === row.chargeMode)
      return result ? result.dictItemName : ''
    },
    handleChargeSource (row) {
      return row.chargeSource === '1' ? '线下' : '线上'
    },
    handleSizeChange (val) {
      this.page.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.page.pageNum = val
      this.getTableData()
    },
    handleSizeChangeLeft (val) {
      this.pageLeft.pageSize = val
      this.getTableDataLeft()
    },
    handleCurrentChangeLeft (val) {
      this.pageLeft.pageNum = val
      this.getTableDataLeft()
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-form {
    /*width: 570px;*/
    margin: 20px auto 0;
  }

  .el-col-2 {
    margin-left: 36px;
    width: 0.33333%;
  }

  .img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    display: block;
    margin-top: 15px;
  }

  .el-autocomplete,
  .inline-input {
    display: block;
  }
  .form-box {
    /deep/ .el-main {
      padding: 0 0 0 20px;
      .demo-form-inline {
        .el-form-item--medium {
          .el-form-item__label {
            min-width: 10px;
          }
        }
      }
    }
    .page-box {
      border: none;
    }
    .el-aside {
      background-color: #fff;
    }
    .user-info {
      div {
        color: #666;
        font-size: 14px;
        margin-top: 10px;
      }
    }
    .el-date-editor {
      width: 290px;
    }
    .totalNumber {
      margin-top: 5px;
      margin-bottom: 5px;
      font-size: 13px;
      color: #777;
    }
    /deep/ .greenColumn {
      color: #67C23A;
    }
    /deep/.form-box {
      .page-box {
        .el-autocomplete {
          .el-input {
            width: 100%;
          }
        }
      }
    }
  }

</style>
